export const subscribe = (eventName: string, listener: EventListener): void => {
  document.addEventListener(eventName, listener);
};

export const unsubscribe = (
  eventName: string,
  listener: EventListener
): void => {
  document.removeEventListener(eventName, listener);
};

export const publish = (eventName: string, data: any): void => {
  const event = new CustomEvent(eventName, { detail: data });
  document.dispatchEvent(event);
};
